import {Component, OnInit} from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import {faTimesCircle} from '@fortawesome/free-regular-svg-icons';

@Component({
    selector: 'app-payment-error',
    templateUrl: './payment-error.component.html',
    styleUrls: ['./payment-error.component.scss']
})
export class PaymentErrorComponent implements OnInit {
    faTimesCircle = faTimesCircle;
    linkTo: string;

    constructor(private route: ActivatedRoute) {
        if (sessionStorage.getItem('cod_contract')) {
            this.linkTo = `/contratos/${sessionStorage.getItem('cod_contract')}`;
        } else {
            this.linkTo = '/contratos';
        }


    }

    ngOnInit(): void {
    }

}
